import dayjs from "dayjs";

const tabBreakpoint = 960;
const mobileBreakpoint = 480;
const auth_token = "14C9C3F08A234B49BDCDD7AF6858FB93";
const access_token = "access_token";
const minDate = dayjs("01-01-2015");

export { tabBreakpoint, mobileBreakpoint, auth_token, access_token, minDate };
